import { render, staticRenderFns } from "./UserGroups.vue?vue&type=template&id=a228e1a8&scoped=true"
import script from "./UserGroups.vue?vue&type=script&lang=js"
export * from "./UserGroups.vue?vue&type=script&lang=js"
import style0 from "./UserGroups.vue?vue&type=style&index=0&id=a228e1a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a228e1a8",
  null
  
)

export default component.exports